import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import InvoiceCostAllocation from '../iesire/InvoiceCostAllocation';

export const inputFingerprint = doc => JSON.stringify([
  ['id','tip_document','tip_factura','bxdoc_date','bxinput_date','bxcont_id','account_id','contact_id',
    'bxvaluta_id','bxvaluta_curs','bxcurs_invoice','e_tva_inc'].map(k => doc[k]),
  (doc.linii || []).map(l => ['id','row_uid','bxpart_id','bxcont_id','bxcantitate','bxvprice','bxvat_id',
    'bxvamount','source_aviz_line_id'].map(k => l[k]))]);

const InputCostAllocation = forwardRef(function InputCostAllocation({ doc, onChange, disabled }, ref) {
  const inner = useRef(null);
  useImperativeHandle(ref, () => ({ prepare: async payload => {
    // Validate the visible document; the server validates the final accounting bases again.
    const groups = await inner.current.prepare(doc);
    if (groups === undefined) return payload;
    return { ...payload, cost_allocation: groups,
      linii: (payload.linii || []).map(l => ({ ...l, cost_alloc: [] })) };
  } }));
  return <InvoiceCostAllocation ref={inner} doc={doc} onChange={onChange} disabled={disabled}
    endpoint="/intrare/cost-allocation-preview" fingerprintOf={inputFingerprint}
    previewWhenDisabled={!!doc.bxfinal_bool}
    lineKey={l => l?.id || l?.row_uid}
    ready={d => d.contact_id && (d.bxcont_id || d.account_id) && d.linii?.length &&
      d.linii.every(l => l.bxpart_id && Number(l.bxcantitate))} />;
});
export default InputCostAllocation;
